import {API} from 'common/api';
import {Position} from 'iq-positions/types';

export const getPositions = async () => {
  return (await API.get('/v1/positions')) as unknown as Position[];
};
